import React, { useState } from 'react'
import { Edit3, Trash2, User } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { getImageUrl } from '@/services/authorService'

export function AuthorRow({ author, confirming, onEdit, onAskDelete, onCancelDelete, onDelete }) {
  const [imageError, setImageError] = useState(false)

  return (
    <div
      className="flex cursor-pointer items-center gap-4 border-b border-border px-4 py-3 last:border-b-0 hover:bg-accent/50"
      onClick={() => onEdit(author)}
    >
      <div className="flex h-12 w-12 shrink-0 items-center justify-center overflow-hidden rounded-full bg-muted">
        {author.image && !imageError ? (
          <img
            src={getImageUrl(author.image)}
            alt={author.full_name}
            className="h-full w-full object-cover"
            onError={() => setImageError(true)}
          />
        ) : (
          <User className="h-5 w-5 text-muted-foreground" />
        )}
      </div>
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium">{author.full_name}</p>
        <p className="truncate text-xs text-muted-foreground">
          {author.email || 'No email'}{author.role?.name ? ` · ${author.role.name}` : ''}
        </p>
      </div>
      <div className="w-40 shrink-0 truncate text-sm text-muted-foreground">{author.contact_number || '—'}</div>
      <div className="relative flex shrink-0 items-center gap-1.5" onClick={(event) => event.stopPropagation()}>
        <Button type="button" variant="outline" size="sm" onClick={() => onEdit(author)}>
          <Edit3 className="mr-1.5 h-3.5 w-3.5" /> Edit
        </Button>
        <Button type="button" variant="outline" size="sm" className="text-destructive" onClick={() => onAskDelete(author.id)}>
          <Trash2 className="h-3.5 w-3.5" />
        </Button>
        {confirming ? (
          <div className="absolute right-0 top-full z-10 mt-1 w-56 rounded-md border border-border bg-popover p-3 shadow-md">
            <p className="text-sm font-medium">Delete this author?</p>
            <div className="mt-2 flex gap-2">
              <Button type="button" variant="destructive" size="sm" onClick={() => onDelete(author.id)}>Delete</Button>
              <Button type="button" variant="outline" size="sm" onClick={onCancelDelete}>Cancel</Button>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  )
}
